import GenericEditForm from "../../../../components/GenericEditForm";

function EditActiveCategory() {
  return (
    <GenericEditForm
      title="Categoría de Activo"
      endpoint="/active-categories"
      backTo="/actives/categories"
      fields={[
        {
          name: "name",
          label: "Nombre",
          type: "text",
          placeholder: "Nombre de la categoría",
          required: true,
        },
        {
          name: "description",
          label: "Descripción",
          type: "textarea",
          placeholder: "Descripción de la categoría",
          required: false,
        },
      ]}
    />
  );
}

export default EditActiveCategory;
